type CorrectionDraftSession = {
  results: Array<{
    previewRow: {
      sourceRowNumber: number
      rawLine: string
    }
    issues: Array<{
      severity: string
    }>
  }>
}

export const hasErrorIssues = (issues: Array<{ severity: string }>): boolean => {
  return issues.some((issue) => issue.severity === 'error')
}

export type SkippedRowCorrection = {
  sourceRowNumber: number
  nextRawLine: string
}

export const buildSkippedRowCorrectionDrafts = (
  session: CorrectionDraftSession | null,
  existingDrafts?: Record<number, string>
): Record<number, string> => {
  if (!session) return {}

  return session.results.reduce<Record<number, string>>((drafts, result) => {
    if (!hasErrorIssues(result.issues)) return drafts
    drafts[result.previewRow.sourceRowNumber] = existingDrafts?.[result.previewRow.sourceRowNumber] ?? result.previewRow.rawLine
    return drafts
  }, {})
}

export const collectChangedSkippedRowCorrections = (
  session: CorrectionDraftSession | null,
  drafts: Record<number, string>
): SkippedRowCorrection[] => {
  if (!session) return []

  return session.results.flatMap((result) => {
    if (!hasErrorIssues(result.issues)) return []

    const sourceRowNumber = result.previewRow.sourceRowNumber
    const nextRawLine = drafts[sourceRowNumber] ?? result.previewRow.rawLine

    if (nextRawLine === result.previewRow.rawLine) return []

    return [{
      sourceRowNumber,
      nextRawLine
    }]
  })
}